import { render } from "./uiSkeleton.vue?vue&type=template&id=07cd54be&scoped=true"
import script from "./uiSkeleton.vue?vue&type=script&lang=js"
export * from "./uiSkeleton.vue?vue&type=script&lang=js"

import "./uiSkeleton.vue?vue&type=style&index=0&id=07cd54be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cd54be"]])

export default __exports__